// MIT License - Copyright (c) 2026 Doug McNall

export const Warhammer40kAliensPlanets = {
  planets: {
    1100: ['spacemarine', 'imperialguard', 'inquisitor', 'techpriest'],
    1101: ['techpriest', 'skitarii'],
    1102: ['imperialguard', 'chaosmarine', 'daemon'],
    1103: ['imperialguard', 'ork', 'spacemarine'],
    1104: ['spacemarine', 'ultramarine'],
    1105: ['spacewolf', 'spacemarine'],
    1106: ['bloodangel', 'spacemarine'],
    1107: ['darkeldar', 'haemonculus'],
    1108: ['eldar', 'farseer'],
    1109: ['tau', 'firewarrior', 'ethereal'],
    1110: ['necron', 'necronlord'],
    1111: ['daemon', 'chaosmarine', 'chaoslord']
  },
  randomEncounters: ['ork', 'tyranid', 'chaosmarine', 'necron'],
  hostileSpecies: ['ork', 'tyranid', 'chaosmarine', 'daemon', 'necron', 'darkeldar'],
  friendlyTraders: ['imperialguard', 'techpriest', 'tau']
};

export default Warhammer40kAliensPlanets;
